import React from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import { hasRole } from "@/lib/auth";

interface AdminRouteProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
}

/**
 * AdminRoute component that checks for admin access based on the user's role
 * returned from the backend JWT response.
 */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const isAdmin = hasRole(user, "ADMIN");

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
